export const preStart = 'preorderStart'
export const preEnd = 'preorderEnd'
export const pickupStart = 'pickupStart'
export const generalInfo = 'generalInfo'

export const dropEvents = {
  '2026-10-26':
    {
      title: 'Pre-orders',
      description: 'Starting at 7pm',
      type: preStart,
      dropRef: 'Oct 30'
    },
  '2026-10-27':
    {
      title: 'Pre-orders',
      start: 'Ending at 9pm',
      description: '',
      type: preEnd,
      dropRef: 'Oct 30'
    },
  '2026-10-30':
    {
      title: 'Pickup',
      description: 'Starting at 11am',
      items: ['Cascade', 'Red Wheat Love'],
      type: pickupStart
    },
  '2026-11-02':
          {
            title: 'Pre-orders',
            description: 'Starting at 7pm',
            type: preStart,
            dropRef: 'Nov 6'
          },
  '2026-11-03':
          {
            title: 'Pre-orders',
            description: 'Ending at 7pm',
            type: preEnd,
            dropRef: 'Nov 6'
          },
  '2026-11-06':
          {
            title: 'Pickup',
            description: 'Starting at 11am',
            items: ['Trail Mix', 'Minnehaha', 'Pizza Dough'],
            type: pickupStart
          }
  ,
  '2026-11-09':
          {
            title: 'Pre-orders',
            description: 'Starting at 7pm',
            type: preStart,
            dropRef: 'Nov 13'
          },
  '2026-11-10':
          {
            title: 'Pre-orders',
            description: 'Ending at 7pm',
            type: preEnd,
            dropRef: 'Nov 13'
          },
  '2026-11-13':
          {
            title: 'Pickup',
            description: 'Starting at 11am',
            items: ['Bagels', 'Baguettes'],
            type: pickupStart
          },
  '2026-11-16':
          {
            title: 'Pre-orders',
            description: 'Starting at 7pm',
            type: preStart,
            dropRef: 'Nov 20'
          },
  '2026-11-17':
          {
            title: 'Pre-orders',
            description: 'Ending at 7pm',
            type: preEnd,
            dropRef: 'Nov 20'
          },
  '2026-11-20':
          {
            title: 'Pickup',
            description: 'Starting at 11am',
            items: ['Olive', 'Spelt or Rustique'],
            type: pickupStart
          },
  '2026-11-26':
          {
            title: 'Thanksgiving',
            type: generalInfo
          },
  '2026-12-24':
          {
            title: 'Christmas Eve',
            type: generalInfo
          },
  '2026-12-25':
          {
            title: 'Christmas',
            type: generalInfo
          }
};